// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ThumbsUpIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20.88 9.24A3.84 3.84 0 0018 8h-3V6c0-2.63-1.51-4-3-4a1 1 0 00-.89.55L7.38 10H5a3.16 3.16 0 00-3 3v6a3.16 3.16 0 003 3h12c1.4 0 4.7-.88 5-8.94a4.86 4.86 0 00-1.12-3.82zM4 19v-6a1.17 1.17 0 011-1h2v8H5a1.17 1.17 0 01-1-1zm16-6.07c-.13 4.3-1.3 7.07-3 7.07H9v-8.78l3.48-7A2.58 2.58 0 0113 6v3a1 1 0 001 1h4a1.84 1.84 0 011.4.58 3 3 0 01.6 2.35z"/></svg>'} />;

ThumbsUpIcon.displayName = 'ThumbsUpIcon';

export default ThumbsUpIcon;
